import { TutorsResponse } from '../types';
import { format } from 'rut.js';

export function useSelectOptions(allTutors: TutorsResponse['allTutors']) {
  return allTutors.map((tutor) => {
    return {
      label: `${tutor.account.name} ${tutor.account.lastNames}, ${format(
        tutor.account.run,
        { dots: true },
      )}`,
      value: tutor.account.teacherId,
      email: tutor.account.email,
    };
  });
}
